import { Reveal } from "./Reveal";

const QUOTES = [
  {
    quote:
      "Guests are still writing to us about the meal a year later. Kasey didn't cater our wedding — she authored it.",
    name: "Alexandra & James Whitfield",
    role: "Estate Wedding, 180 guests",
  },
  {
    quote:
      "The most operationally invisible team I have worked with in fifteen years of planning. The food simply appeared — flawless.",
    name: "Margaux Delacroix",
    role: "Wedding & Events Planner",
  },
  {
    quote:
      "Our board dinner felt like a private three-star room. Every dietary need handled before we thought to ask.",
    name: "Daniel Okafor",
    role: "CEO, Meridian Capital Summit",
  },
];

export const Testimonials = () => (
  <section data-testid="testimonials-section" className="bg-bone py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mb-16">
        <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.3em] text-ink-mute">
          From the Table
        </p>
        <h2 className="max-w-2xl font-serif text-3xl leading-tight tracking-tight text-noir sm:text-4xl lg:text-5xl">
          Word travels <span className="italic text-truffle">faster than dessert</span>
        </h2>
      </Reveal>

      <div className="grid gap-8 md:grid-cols-3">
        {QUOTES.map((q, i) => (
          <Reveal key={q.name} delay={i * 0.12}>
            <figure
              data-testid={`testimonial-card-${i + 1}`}
              className="flex h-full flex-col justify-between border-t-2 border-gold/60 pt-8"
            >
              <blockquote className="font-serif text-xl italic leading-relaxed text-noir sm:text-2xl">
                <span className="mr-1 font-serif text-4xl leading-none text-gold">"</span>
                {q.quote}
              </blockquote>
              <figcaption className="mt-8">
                <p className="text-sm font-medium text-noir">{q.name}</p>
                <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.18em] text-ink-mute">
                  {q.role}
                </p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
